import { render, staticRenderFns } from "./ManageUserGroupsModal.vue?vue&type=template&id=0712cc14&scoped=true&"
import script from "./ManageUserGroupsModal.vue?vue&type=script&lang=js&"
export * from "./ManageUserGroupsModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageUserGroupsModal.vue?vue&type=style&index=0&id=0712cc14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0712cc14",
  null
  
)

export default component.exports